import { toast, Bounce } from 'react-toastify';

export const alertMessage = function (value = '', options = {}) {
  const { type = 'info', ...restOptions } = options;
  const toastFn = toast[type] || toast.info;

  toastFn(value, {
    position: 'top-center',
    newestOnTop: true,
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: 'colored',
    transition: Bounce,
    ...restOptions,
  });
};

export const alertWarning = function (value = '', options = {}) {
  alertMessage(value, { type: 'warn', ...options });
};
